module.exports = __webpack_public_path__ + "media/img/favicon-32x32-995d6716b8ba1ac0c8f9dba8b5950209.png";